function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import hasInterface from '../../../../../hasInterface';
import Position from '../../geomgraph/Position';
import Coordinate from '../../geom/Coordinate';
import Orientation from '../../algorithm/Orientation';
import Collections from '../../../../../java/util/Collections';
import DirectedEdge from '../../geomgraph/DirectedEdge';
import LineSegment from '../../geom/LineSegment';
import Comparable from '../../../../../java/lang/Comparable';
import ArrayList from '../../../../../java/util/ArrayList';
import List from '../../../../../java/util/List';
var SubgraphDepthLocater = /*#__PURE__*/function () {
  function SubgraphDepthLocater() {
    _classCallCheck(this, SubgraphDepthLocater);
    SubgraphDepthLocater.constructor_.apply(this, arguments);
  }
  return _createClass(SubgraphDepthLocater, [{
    key: "findStabbedSegments",
    value: function findStabbedSegments() {
      if (arguments.length === 1) {
        var stabbingRayLeftPt = arguments[0];
        var stabbedSegments = new ArrayList();
        for (var i = this._subgraphs.iterator(); i.hasNext();) {
          var bsg = i.next();
          var env = bsg.getEnvelope();
          if (stabbingRayLeftPt.y < env.getMinY() || stabbingRayLeftPt.y > env.getMaxY()) continue;
          this.findStabbedSegments(stabbingRayLeftPt, bsg.getDirectedEdges(), stabbedSegments);
        }
        return stabbedSegments;
      } else if (arguments.length === 3) {
        if (hasInterface(arguments[2], List) && arguments[0] instanceof Coordinate && arguments[1] instanceof DirectedEdge) {
          var _stabbingRayLeftPt = arguments[0];
          var dirEdge = arguments[1];
          var _stabbedSegments = arguments[2];
          var pts = dirEdge.getEdge().getCoordinates();
          for (var _i = 0; _i < pts.length - 1; _i++) {
            this._seg.p0 = pts[_i];
            this._seg.p1 = pts[_i + 1];
            if (this._seg.p0.y > this._seg.p1.y) this._seg.reverse();
            var maxx = Math.max(this._seg.p0.x, this._seg.p1.x);
            if (maxx < _stabbingRayLeftPt.x) continue;
            if (this._seg.isHorizontal()) continue;
            if (_stabbingRayLeftPt.y < this._seg.p0.y || _stabbingRayLeftPt.y > this._seg.p1.y) continue;
            if (Orientation.index(this._seg.p0, this._seg.p1, _stabbingRayLeftPt) === Orientation.RIGHT) continue;
            var depth = dirEdge.getDepth(Position.LEFT);
            if (!this._seg.p0.equals(pts[_i])) depth = dirEdge.getDepth(Position.RIGHT);
            var ds = new DepthSegment(this._seg, depth);
            _stabbedSegments.add(ds);
          }
        } else if (hasInterface(arguments[2], List) && arguments[0] instanceof Coordinate && hasInterface(arguments[1], List)) {
          var _stabbingRayLeftPt2 = arguments[0];
          var dirEdges = arguments[1];
          var _stabbedSegments2 = arguments[2];
          for (var _i2 = dirEdges.iterator(); _i2.hasNext();) {
            var de = _i2.next();
            if (!de.isForward()) continue;
            this.findStabbedSegments(_stabbingRayLeftPt2, de, _stabbedSegments2);
          }
        }
      }
    }
  }, {
    key: "getDepth",
    value: function getDepth(p) {
      var stabbedSegments = this.findStabbedSegments(p);
      if (stabbedSegments.size() === 0) return 0;
      var ds = Collections.min(stabbedSegments);
      return ds._leftDepth;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return SubgraphDepthLocater;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);
}();
export { SubgraphDepthLocater as default };
var DepthSegment = /*#__PURE__*/function () {
  function DepthSegment() {
    _classCallCheck(this, DepthSegment);
    DepthSegment.constructor_.apply(this, arguments);
  }
  return _createClass(DepthSegment, [{
    key: "compareTo",
    value: function compareTo(obj) {
      var other = obj;
      if (this._upwardSeg.minX() >= other._upwardSeg.maxX()) return 1;
      if (this._upwardSeg.maxX() <= other._upwardSeg.minX()) return -1;
      var orientIndex = this._upwardSeg.orientationIndex(other._upwardSeg);
      if (orientIndex !== 0) return orientIndex;
      orientIndex = -1 * other._upwardSeg.orientationIndex(this._upwardSeg);
      if (orientIndex !== 0) return orientIndex;
      return this._upwardSeg.compareTo(other._upwardSeg);
    }
  }, {
    key: "compareX",
    value: function compareX(seg0, seg1) {
      var compare0 = seg0.p0.compareTo(seg1.p0);
      if (compare0 !== 0) return compare0;
      return seg0.p1.compareTo(seg1.p1);
    }
  }, {
    key: "toString",
    value: function toString() {
      return this._upwardSeg.toString();
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return DepthSegment;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [Comparable];
    }
  }]);
}();
DepthSegment.constructor_ = function () {
  this._upwardSeg = null;
  this._leftDepth = null;
  var seg = arguments[0];
  var depth = arguments[1];
  this._upwardSeg = new LineSegment(seg);
  this._leftDepth = depth;
};
SubgraphDepthLocater.DepthSegment = DepthSegment;
SubgraphDepthLocater.constructor_ = function () {
  this._subgraphs = null;
  this._seg = new LineSegment();
  var subgraphs = arguments[0];
  this._subgraphs = subgraphs;
};